export default {
  initialCheck: false,
  loading: false,
  user: null,
  loggedIn: false,
  error: null,
  invalidLogin: false,
  authUsed: false
}